<template>
  <ais-refinement-list
    :transformItems="transformItems"
    :attribute="filter.id"
    :limit="999"
    :sort-by="['name:asc']"
    operator="and"
  >
    <template v-slot="{ items, refine }">
      <div class="generic-filter">
        <div class="unit-toggle" v-if="isVolume(filter.id)">
          <div class="toggle">
            <span
              :class="{'toggle-option': true, checked: currentUnit === 'gallons'}"
            >
              {{ isFlowRate(filter.id) ? 'gpm' : 'gpf' }}
            </span>
            <label class="switch">
              <input type="checkbox" @change="setUnit" />
              <span class="slider"></span>
            </label>
            <span
              :class="{'toggle-option': true, checked: currentUnit === 'liters'}"
            >
              {{ isFlowRate(filter.id) ? 'Lpm' : 'Lpf' }}
            </span>
          </div>
        </div>
        <div class="filter-values">
          <span v-for="item in items" class="filter-value-wrapper" :key="item.value">
            <span
              class="filter-value"
              :class="{ active: item.isRefined }"
              @click="handleClick(refine, item)"
            >
              <span v-html="formatValue(item.label)" />
            </span>
          </span>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>

<script>
import {
  transformItems,
  isVolume,
  isFlowRate,
  isWaterfree,
  scrollToTopAfterFilterChange
} from '../filters-config';

export default {
  props: {
    filter: {type: Object, required: true}
  },
  data() {
    return {
      currentUnit: 'gallons'
    };
  },
  watch: {
    currentUnit(unit) {
      this.$emit('unit', unit);
    }
  },
  methods: {
    transformItems(items) {
      return transformItems(this.filter, items);
    },
    handleClick(refine, item) {
      refine(item.value);
      scrollToTopAfterFilterChange();
    },
    setUnit(event) {
      if (event.target.checked) {
        this.currentUnit = 'liters';
      } else {
        this.currentUnit = 'gallons';
      }
    },
    formatValue(value) {
      if (isWaterfree(value)) return value;
      if (this.isVolume(this.filter.id) && this.currentUnit === 'liters')
        return this.convertToLiters(value);
      if (this.filter.id === 'product_rough_in_dimensions') return `${value}"`;

      return value;
    },
    convertToLiters(value) {
      if (isWaterfree(value)) return value;
      let array = value.split('/');
      array = array.map(gallons => {
        let value = (parseFloat(gallons) * 3.78541).toFixed(1);
        if (value === '6.1') return '6.0';
        return value;
      });

      return array.join('/');
    },
    isVolume(filterId) {
      return isVolume(filterId);
    },
    isFlowRate(filterId) {
      return isFlowRate(filterId);
    }
  }
};
</script>
